<p-dialog
  header="Ajouter une affaire existante au vivier"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '620px' }"
  styleClass="pool-add-existing-dialog"
  (onHide)="close()"
>
  @if (!selectedResult) {
    <!-- ── Étape 1 : recherche de l'affaire ── -->
    <div class="search-step">
      <div class="field search-field">
        <label for="paed-search">Rechercher une affaire *</label>
        <span class="search-input-wrap">
          <i class="pi pi-search"></i>
          <input
            id="paed-search"
            type="text"
            pInputText
            [ngModel]="searchQuery"
            (ngModelChange)="onSearchQueryChange($event)"
            placeholder="Réf. ML, nom du client, n° de dossier…"
            autocomplete="off"
            autofocus
          />
          @if (searchLoading) {
            <i class="pi pi-spin pi-spinner search-loading"></i>
          }
        </span>
        @if (searchQuery.trim().length > 0 && searchQuery.trim().length < 2) {
          <small class="field-hint">Saisissez au moins 2 caractères.</small>
        }
      </div>

      @if (searchError) {
        <p class="submit-error">
          <i class="pi pi-exclamation-circle"></i>
          {{ searchError }}
        </p>
      }

      @if (searchResults.length > 0) {
        <ul class="search-results" role="listbox">
          @for (result of searchResults; track result.id) {
            <li>
              <button
                type="button"
                class="result-item"
                (click)="selectResult(result)"
              >
                <div class="result-topline">
                  <span class="result-mlref">{{ result.mlRef }}</span>
                  <span class="result-badges">
                    @if (result.marketType?.abbreviation) {
                      <span
                        class="badge badge-market"
                        [pTooltip]="result.marketType!.name"
                        tooltipPosition="top"
                      >
                        {{ result.marketType!.abbreviation }}
                      </span>
                    }
                    <span
                      class="badge badge-erp"
                      [class.is-present]="result.erpPresence.abm"
                      [pTooltip]="
                        result.erpPresence.abm
                          ? 'Affaire présente sur ABM'
                          : 'Affaire non présente sur ABM'
                      "
                      tooltipPosition="top"
                    >
                      ABM
                    </span>
                    <span
                      class="badge badge-erp"
                      [class.is-present]="result.erpPresence.nrj"
                      [pTooltip]="
                        result.erpPresence.nrj
                          ? 'Affaire présente sur NRJ'
                          : 'Affaire non présente sur NRJ'
                      "
                      tooltipPosition="top"
                    >
                      NRJ
                    </span>
                  </span>
                </div>
                @if (result.finalCustomers) {
                  <div class="result-customers">{{ result.finalCustomers }}</div>
                }
                @if (formatResultAddress(result)) {
                  <div class="result-address">
                    <i class="pi pi-map-marker"></i>
                    {{ formatResultAddress(result) }}
                  </div>
                }
                <div class="result-meta">
                  @if (result.folderNumber) {
                    <span class="meta-item">
                      <span class="meta-label">Réf. dossier</span>
                      {{ result.folderNumber }}
                    </span>
                  }
                  @if (result.customerRef) {
                    <span class="meta-item">
                      <span class="meta-label">Réf. client</span>
                      {{ result.customerRef }}
                    </span>
                  }
                  @if (result.agency) {
                    <span class="meta-item">
                      <i class="pi pi-building"></i>
                      {{ result.agency.name }}
                    </span>
                  }
                  @if (formatCreatedAt(result.createdAt)) {
                    <span class="meta-item">
                      <i class="pi pi-calendar"></i>
                      {{ formatCreatedAt(result.createdAt) }}
                    </span>
                  }
                </div>
              </button>
            </li>
          }
        </ul>
      } @else if (searchLoading) {
        <div class="search-state">
          <p-progressSpinner
            styleClass="w-2rem h-2rem"
            strokeWidth="4"
          ></p-progressSpinner>
          <span>Recherche en cours…</span>
        </div>
      } @else if (searchPerformed && !searchError) {
        <div class="search-state">
          <i class="pi pi-inbox"></i>
          <span>Aucune affaire trouvée pour « {{ searchQuery.trim() }} ».</span>
        </div>
      } @else if (!searchError) {
        <div class="search-state search-state-idle">
          <i class="pi pi-search"></i>
          <span>
            Recherchez l'affaire à ajouter au vivier par référence ML, nom de
            client, n° de dossier ou référence client.
          </span>
        </div>
      }
    </div>
  } @else {
    <!-- ── Étape 2 : produits + fenêtre souhaitée ── -->
    <div class="details-step">
      <!-- Récap de l'affaire sélectionnée -->
      <div class="selected-affair">
        <div class="sa-main">
          <div class="result-topline">
            <span class="result-mlref">{{ selectedResult.mlRef }}</span>
            <span class="result-badges">
              @if (selectedResult.marketType?.abbreviation) {
                <span class="badge badge-market">
                  {{ selectedResult.marketType!.abbreviation }}
                </span>
              }
              <span
                class="badge badge-erp"
                [class.is-present]="selectedResult.erpPresence.abm"
              >
                ABM
              </span>
              <span
                class="badge badge-erp"
                [class.is-present]="selectedResult.erpPresence.nrj"
              >
                NRJ
              </span>
            </span>
          </div>
          @if (selectedResult.finalCustomers) {
            <div class="result-customers">
              {{ selectedResult.finalCustomers }}
            </div>
          }
          @if (formatResultAddress(selectedResult)) {
            <div class="result-address">
              <i class="pi pi-map-marker"></i>
              {{ formatResultAddress(selectedResult) }}
            </div>
          }
        </div>
        <button
          type="button"
          class="sa-change-btn"
          (click)="backToSearch()"
          pTooltip="Choisir une autre affaire"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-left"></i>
          Changer
        </button>
      </div>

      @if (detailsLoading) {
        <div class="search-state">
          <p-progressSpinner
            styleClass="w-2rem h-2rem"
            strokeWidth="4"
          ></p-progressSpinner>
          <span>Chargement de l'affaire…</span>
        </div>
      } @else if (detailsError) {
        <p class="submit-error">
          <i class="pi pi-exclamation-circle"></i>
          {{ detailsError }}
        </p>
      } @else {
        <!-- Coordonnées du chantier -->
        @if (geocoding) {
          <small class="field-hint geo-hint">
            <i class="pi pi-spin pi-spinner"></i>
            Géolocalisation de l'adresse du chantier…
          </small>
        } @else if (geoError) {
          <p class="submit-error">
            <i class="pi pi-exclamation-circle"></i>
            {{ geoError }}
          </p>
        } @else if (hasCoordinates && geocoded) {
          <small class="field-hint geo-hint geo-ok">
            <i class="pi pi-check-circle"></i>
            Chantier géolocalisé depuis l'adresse (l'affaire n'avait pas de
            coordonnées).
          </small>
        }

        <!-- Produits planifiables de l'affaire -->
        @if (schedulableProducts.length > 0) {
          <div class="field">
            <label>Produits planifiables de l'affaire</label>
            <ul class="schedulable-products">
              @for (ap of schedulableProducts; track ap.id) {
                <li [class.is-selected]="isSchedulableSelected(ap)">
                  <label class="sp-check">
                    <input
                      type="checkbox"
                      [checked]="isSchedulableSelected(ap)"
                      (change)="toggleSchedulable(ap)"
                    />
                    <span class="sp-name">
                      {{ ap.product.abbreviation || ap.product.name }}
                    </span>
                    <span class="sp-duration">
                      <i class="pi pi-hourglass"></i>
                      {{ formatDuration(ap.product.duration) }}
                    </span>
                  </label>
                  @if (isSchedulableSelected(ap)) {
                    <span class="sp-qty">
                      <button
                        type="button"
                        (click)="changeSchedulableQuantity(ap, -1)"
                        [disabled]="getSchedulableQuantity(ap) <= 1"
                      >
                        −
                      </button>
                      <span>{{ getSchedulableQuantity(ap) }}</span>
                      <button
                        type="button"
                        (click)="changeSchedulableQuantity(ap, 1)"
                      >
                        +
                      </button>
                    </span>
                  }
                </li>
              }
            </ul>
          </div>
        } @else {
          <small class="field-hint">
            Aucun produit planifiable sur cette affaire : sélectionnez le ou
            les produits depuis le catalogue ci-dessous.
          </small>
        }

        <!-- Catalogue (en complément) -->
        <div class="field">
          <label for="paed-products">
            @if (schedulableProducts.length > 0) {
              Ajouter depuis le catalogue (optionnel)
            } @else {
              Produit(s) du catalogue *
            }
          </label>
          <p-multiSelect
            inputId="paed-products"
            [options]="products"
            [ngModel]="selectedProducts"
            (ngModelChange)="onProductsChange($event)"
            optionLabel="name"
            [filter]="true"
            [showToggleAll]="false"
            [loading]="productsLoading"
            placeholder="Sélectionner les produits"
            appendTo="body"
            styleClass="w-full"
          ></p-multiSelect>

          @if (selectedProducts.length > 0) {
            <ul class="selected-products">
              @for (product of selectedProducts; track product.id) {
                <li>
                  <span class="sp-name">
                    {{ product.abbreviation || product.name }}
                  </span>
                  <span class="sp-qty">
                    <button
                      type="button"
                      (click)="changeQuantity(product, -1)"
                      [disabled]="getQuantity(product) <= 1"
                    >
                      −
                    </button>
                    <span>{{ getQuantity(product) }}</span>
                    <button type="button" (click)="changeQuantity(product, 1)">
                      +
                    </button>
                  </span>
                </li>
              }
            </ul>
          }
        </div>

        @if (totalDurationLabel) {
          <small class="field-hint duration-hint">
            <i class="pi pi-hourglass"></i>
            Durée de service estimée : {{ totalDurationLabel }}
          </small>
        }

        <!-- Produits absents d'un ERP -->
        @for (warning of erpWarnings; track warning.productName) {
          <small class="erp-warning">
            <i class="pi pi-exclamation-triangle"></i>
            « {{ warning.productName }} » n'existe pas sur
            {{ warning.missingErps }} : la planification sur un technicien de
            cet ERP pourra être refusée.
          </small>
        }

        <!-- Fenêtre souhaitée (optionnel) : n° de semaine ou dates précises -->
        <div class="wished-block">
          <div class="field week-field">
            <label for="paed-week">Semaine souhaitée (optionnel)</label>
            <div class="week-input-row">
              <span class="week-prefix">S</span>
              <input
                id="paed-week"
                type="number"
                min="1"
                max="53"
                pInputText
                [ngModel]="wishedWeek"
                (ngModelChange)="onWishedWeekChange($event)"
                placeholder="n°"
              />
              @if (wishedWeekHint) {
                <span class="week-hint">
                  <i class="pi pi-calendar"></i>
                  {{ wishedWeekHint }}
                </span>
              }
            </div>
            @if (wishedWeekError) {
              <small class="field-error">{{ wishedWeekError }}</small>
            }
          </div>

          <div class="field-row">
            <div class="field">
              <label for="paed-wished-start">Souhaité à partir du</label>
              <p-datepicker
                inputId="paed-wished-start"
                [(ngModel)]="wishedPlanningStartDate"
                (ngModelChange)="onWishedDatesEdited()"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
                placeholder="jj/mm/aaaa"
                styleClass="w-full"
              ></p-datepicker>
            </div>
            <div class="field">
              <label for="paed-wished-end">Jusqu'au</label>
              <p-datepicker
                inputId="paed-wished-end"
                [(ngModel)]="wishedPlanningEndDate"
                (ngModelChange)="onWishedDatesEdited()"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [readonlyInput]="true"
                [showClear]="true"
                [minDate]="wishedPlanningStartDate ?? undefined"
                appendTo="body"
                placeholder="jj/mm/aaaa"
                styleClass="w-full"
              ></p-datepicker>
            </div>
            <div class="field">
              <label for="paed-deadline">Échéance</label>
              <p-datepicker
                inputId="paed-deadline"
                [(ngModel)]="planningDeadline"
                [dateFormat]="'dd/mm/yy'"
                [showIcon]="true"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
                placeholder="jj/mm/aaaa"
                styleClass="w-full"
              ></p-datepicker>
            </div>
          </div>
        </div>

        @if (submitError) {
          <p class="submit-error">
            <i class="pi pi-exclamation-circle"></i>
            {{ submitError }}
          </p>
        }
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Annuler"
      severity="secondary"
      [outlined]="true"
      [disabled]="submitting"
      (click)="close()"
    ></p-button>
    @if (selectedResult) {
      <p-button
        label="Ajouter au vivier"
        icon="pi pi-plus"
        [loading]="submitting"
        [disabled]="!canSubmit"
        (click)="submit()"
      ></p-button>
    }
  </ng-template>
</p-dialog>
